import { useRouterState } from "@tanstack/react-router";
import {
  FALLBACK_PROFILE,
  type PublicBusinessProfile,
} from "@/lib/business-profile.functions";

/**
 * Läser de publika företagsuppgifterna (NAP) som rot-routen hämtar från
 * Admin → Företagsuppgifter. Faller tillbaka på kodens fakta om laddningen
 * inte hunnit klart eller misslyckas.
 */
export function useBusinessProfile(): PublicBusinessProfile {
  const data = useRouterState({
    select: (s) =>
      (s.matches[0]?.loaderData as { business?: PublicBusinessProfile } | undefined)
        ?.business,
  });
  return data ?? FALLBACK_PROFILE;
}
